export const globalSummary = {
  dataQualityDashboardTitle: {
    default: ['Qualidade de dados'],
    boavista: ['Higienização de dados'],
  },
}
